// Generated by scripts/update-seeq-icons.js from src/svg/seeq/line-bars.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcLineBars = {
  prefix: 'fak',
  iconName: 'line-bars' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f939',
    'M230.4 512h-107.5c-5.1 0-10.2 5.1-10.3 15.4v230.4c0 5.1 5.1 5.1 5.2 5.1h117.7c5.1 0 5.1-5.1 5.1-5.1v-230.4c0-10.2-5.1-15.4-10.2-15.4zM399.4 261.1h-107.6c-5.1 0-10.2 5.1-10.2 10.3v476.1c0 5.1 5.1 5.1 5.1 5.1h117.8c0 10.2 5.1 5.1 5.1 0v-476.1c0-5.1-5.1-15.4-10.2-15.4zM732.2 476.2h-107.6c-5.1 0-10.2 5.1-10.2 10.2v266.2c0 5.1 5.1 5.1 5.1 5.2h117.8c5.1 0 5.1-5.1 5.1-5.2v-266.2c5.1-5.1 0-10.2-10.2-10.2zM563.2 373.8h-102.4c-5.1 0-10.2 5.1-10.2 10.2v368.6c0 5.1 5.1 5.1 5.1 5.2h117.7c5.1 0 5.1-5.1 5.2-5.2v-368.6c0-5.1-5.1-10.2-15.4-10.2zM901.1 609.3h-107.5c-5.1 0-10.2 5.1-10.2 10.2v128c0 5.1 5.1 5.1 5.1 5.1h117.7c5.1 0 5.1-5.1 5.2-5.1v-122.9c0-10.2-5.1-15.4-10.3-15.3z',
  ],
} satisfies IconDefinition;
